import { Sparkles, Ticket } from 'lucide-react';
import { AtlasShell } from '../components/AtlasShell';
import './wishes.css';
export function Wishes() {
  return (
    <AtlasShell className="atlas-wishes">
      <div className="atlas-subpage wishes-page">
        <section className="wish-hero">
          <img
            className="wish-hero-art"
            src="/art/island-atlas-v9/wish-postoffice.webp"
            width="1440"
            height="600"
            alt=""
          />
          <div className="wish-intro">
            <div className="wish-eyebrow">
              <Sparkles size={16} />
              心愿榜
            </div>
            <h1>下一款游戏，听你的。</h1>
            <p>把想玩的游戏写成心愿，让小岛多一种好玩。</p>
          </div>
        </section>
        <aside className="wish-preview-notice">
          <Ticket size={22} />
          <div>
            <strong>心愿邮局，正在准备中</strong>
            <p>提交心愿、投票和制作进度将在后续开放。</p>
          </div>
          <span>敬请期待</span>
        </aside>
        <div className="wish-preview-empty">
          <Ticket size={36} />
          <h2>留一个位置，给你的奇思妙想</h2>
          <p>这里将展示岛民们想玩的游戏。</p>
        </div>
      </div>
    </AtlasShell>
  );
}
